import { render } from "./PartnershipProgramContent.vue?vue&type=template&id=e4545712&scoped=true"
import script from "./PartnershipProgramContent.vue?vue&type=script&lang=js"
export * from "./PartnershipProgramContent.vue?vue&type=script&lang=js"

import "./PartnershipProgramContent.vue?vue&type=style&index=0&id=e4545712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4545712"]])

export default __exports__